import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle
} from "@mui/material";
import { ReactElement } from "react";

import { PromptTemplate } from "../../../types/prompt-template";

interface DeleteConfirmationDialogProps {
  open: boolean;
  template: PromptTemplate | null;
  onConfirm: () => void;
  onCancel: () => void;
}

const DeleteConfirmationDialog = ({
  open,
  template,
  onConfirm,
  onCancel
}: DeleteConfirmationDialogProps): ReactElement => (
  <Dialog open={open} onClose={onCancel}>
    <DialogTitle>Delete Lens</DialogTitle>
    <DialogContent>
      <DialogContentText>
        Are you sure you want to delete the lens &quot;{template?.title}&quot;? This action cannot be undone.
      </DialogContentText>
    </DialogContent>
    <DialogActions>
      <Button onClick={onCancel}>Cancel</Button>
      <Button onClick={onConfirm} color="error">
        Delete
      </Button>
    </DialogActions>
  </Dialog>
);

export default DeleteConfirmationDialog;
